<!-- <div class="container">
    <div class="row">
        <div class="error-template">
            <h1>Oops!</h1>
            <h2>404 Not Found</h2>
            <div class="error-details">
                Sorry, an error has occured, Requested page not found!<br>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="page-wrap d-flex flex-row align-items-center">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <div class="mb-4 lead">The requested page could not be found.</div>
            </div>
        </div>
    </div>
</div> -->
<div class="col-12 site-inner-banner pl-0 pr-0">
    <div class="container">
        <h1></h1>
    </div>
</div>
<section>
    <div class="wrapper">
        <div class="col-12 full-width-center">
            <div class="container">
                <div class="col-12 main-title">
                    <div>
                        The requested page could not be found.
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="internal_pages">
    <div class="container">
        <div class="row">

            <div class="col-md-12 col-sm-12 in_main main-contents-section form-section">

                <div>
                    <div class="hidden"></div>

                    <div>
                        The requested page could not be found.
                    </div>

                </div>
            </div>
        </div>
    </div>
</section> -->